/**
 * personalised-ab-router.js
 *
 * CUSTOM: V2 router for review and library pages.
 * V1 route constants remain temporarily so stale links can be rewritten to V2.
 *
 * Must load synchronously immediately after personalised-config.js.
 *
 * Idempotent — safe to load more than once (guards against double-init).
 */
(function() {
  window.personalised = window.personalised || {};

  // Guard: do not re-initialise if already loaded.
  if (window.personalised.abRouter) return;

  var config = window.personalised.config;
  if (!config || !config.routes) return;

  var reviewV1 = config.routes.reviewV1 || '/pages/personalised-review';
  var reviewV2 = config.routes.reviewV2 || '/pages/review-pack';
  var libraryV1 = config.routes.libraryV1 || '/pages/personalised-library';
  var libraryV2 = config.routes.libraryV2 || '/pages/library-v2';

  function getAssignment() {
    return 'v2';
  }

  function getReviewUrl() {
    return reviewV2;
  }

  function getLibraryUrl() {
    return libraryV2;
  }

  /**
   * Idempotent link rewriter — updates all elements with
   * data-personalised-review-link or data-personalised-library-link,
   * plus any <a> whose href points to V1 URLs, to the A/B-assigned URL.
   * Safe to call multiple times.
   */
  function rewritePersonalisedLinks() {
    var reviewUrl = getReviewUrl();
    var libraryUrl = getLibraryUrl();

    if (reviewUrl) {
      document.querySelectorAll('a[data-personalised-review-link]').forEach(function(link) {
        link.href = reviewUrl;
      });
      document.querySelectorAll('a[href$="' + reviewV1 + '"]').forEach(function(link) {
        link.href = reviewUrl;
      });
    }

    if (libraryUrl) {
      document.querySelectorAll('a[data-personalised-library-link]').forEach(function(link) {
        link.href = libraryUrl;
      });
      document.querySelectorAll('a[href$="' + libraryV1 + '"]').forEach(function(link) {
        link.href = libraryUrl;
      });
    }
  }

  config.routes.review = getReviewUrl();
  config.routes.library = getLibraryUrl();

  window.personalised.abRouter = {
    getAssignment: getAssignment,
    getReviewUrl: getReviewUrl,
    getLibraryUrl: getLibraryUrl,
    rewritePersonalisedLinks: rewritePersonalisedLinks
  };

  // Rewrite on initial page load.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rewritePersonalisedLinks);
  } else {
    rewritePersonalisedLinks();
  }

  // Rewrite after cart drawer/cart content is dynamically re-rendered.
  document.addEventListener('cart:updated', rewritePersonalisedLinks);
})();
